import { render, staticRenderFns } from "./mb-payment-modal.vue?vue&type=template&id=0683fbba&"
import script from "./mb-payment-modal.vue?vue&type=script&lang=js&"
export * from "./mb-payment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports